module.exports = __webpack_public_path__ + "img/ClickForSound_28.45a30d55.png";